import { Input, Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import {UserService} from "../../../services/user.service";
import {AppDataService} from "../../../services/app-data.service";
import {InstagramUserBean} from "../../../beansts/instagram.user.bean";
import {EventBean} from "../../../beansts/Event";
import {CompanyBean} from "../../../beansts/company.bean";
import { TranslationService } from '../../../services/translation.service';

import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
declare let $: any;
declare var Swal : any;

@Component({
    selector : 'header-component',
    templateUrl:'header-component.html',

})
export class HeaderComponent implements OnInit, OnDestroy{



  public LoginEnter;


  public constructor( private _router : Router,public translate: TranslationService,private _auth : UserService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {

  }

    public ngOnInit(): any {
      let user=this._appData.instagramUser;
      if (!user){
        //try memory
        if (typeof window !== "undefined" && localStorage) {
          let memuser=localStorage.getItem('instagramUser');
          if (memuser && memuser !== "undefined"){
            this._appData.instagramUser=JSON.parse(memuser);
            user=this._appData.instagramUser;
          }
        }
      }
      if (user){
        if (this._appData.page=='' || this._appData.page=='portal'){
          this.LoginEnter=this.translate.instant("ENTER");
        }
        else{
          this.LoginEnter=this.translate.instant("PROFILE");
        }
      }
      else{
        this.LoginEnter=this.translate.instant("LOGIN_SIGNUP");
      }

    }

    public onChange (params){
      this.ngOnInit();
    };

    public enter(): void {
      
      let user=this._appData.instagramUser;
      if (!user){
        //try memory
        if (typeof window !== "undefined" && localStorage) {
          let memuser=localStorage.getItem('instagramUser');
          if (memuser && memuser !== "undefined"){
            this._appData.instagramUser=JSON.parse(memuser);
            user=this._appData.instagramUser;
          }
        }
      }
      if (user){
        if (this._appData.page==''){
          $('#main').css('height','');
          if (!this._appData.instagramUser.event || this._appData.instagramUser.event!='1592880902713'){
            this._appData.instagramUser.event='1592880902713'
            this._appData.instagramUser.room='1644803653158' 
          }
          this._router.navigate(['/game/'])  
        }
        else {
          $('#profileModal').modal("show");
          $('#redrawProfile').click()

        }
      }
      else{
        $('#registerSocialModal').modal("show");
      }


    }

    public ngOnDestroy() : any {
    }






  
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+header-footer/header/header-component.ts